/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var request = window.core.backend.request,
    Epg = require('./epg.class');

function Channel ( config ) {
    var prop;

    config = config || {};

    for ( prop in config ) {
        this[prop] = config[prop];
    }
}


Channel.prototype = {};
Channel.prototype.constructor = Channel;

/**
 * Toggle favorite state
 *
 * @param {function} cb after toggle
 */
Channel.prototype.toggleFavorite = function ( cb ) {
    var self = this;

    request('tv-channels/' + this.id, {
        method: 'PUT',
        body: JSON.stringify({favorite: !self.favorite}),
        onload: function ( error ) {

            if ( error ) {
                cb(true);
            } else {
                self.favorite = !self.favorite;
                cb(false, self.favorite);
            }
        },
        onerror: function () {
            cb(true);
        }
    });
};

Channel.prototype.getUrl = function ( callback ) {
    if ( this.url ) {
        callback(false, {url:this.url, solution: this.solution});
    } else {
        request('tv-channels/' + this.id + '/link', {
            onload: function ( error, response ) {
                if ( error ) {
                    callback(error, null);
                } else {
                    callback(false, {url: response.data.url, solution: response.data.solution});
                }
            },
            onerror: function () {
                callback(true, null);
            }
        });
    }
};


Channel.prototype.getEpg = function ( config, cb ) {
    var self = this,
        now = new Date(),
        url, from, to;

    config = config || {};

    // use 7 days before current and next 7 days to get epg
    from = +new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
    to =  +new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7);
    from = Math.round(from/1000);
    to  = Math.round(to/1000);

    from = config.from || from;
    to = config.to || to;

    url = 'tv-channels/' + this.id + '/epg/?from=' + from + '&to=' + to;
    request(url, {
        onload: function ( error, response ) {
            var result = [];

            if ( error && cb ) {
                cb(true, []);
            } else {
                response.data.forEach(function ( config ) {
                    config.channel = self;
                    result.push(new Epg(config));
                });
                cb(false, result);
            }
        },
        onerror: function () {
            cb(true, []);
        }
    });
};

Channel.prototype.setLast = function ( cb ) {
    request('storage', {
        body: JSON.stringify({value: this.id, key: 'lastChannel'}),
        method: 'POST',
        onload: function ( error ) {
            if ( error && cb ) {
                cb(error);
            } else if ( cb ) {
                cb(false);
            }
        },
        onerror: function () { if ( cb ) { cb(true, null); } }
    });
};


module.exports = Channel;



//////////////////
// WEBPACK FOOTER
// ./src/js/channel.class.js
// module id = 4
// module chunks = 0